import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';

const API_KEY = 'AIzaSyDHxJBuBItJslGeW0WgFIiPyfvhWwuUEA4';

function App() {
  const [isOpen, setIsOpen] = useState(false);
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([]);
  const chatRef = useRef(null);

  // Handle clicks outside chat box to close it
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (chatRef.current && !chatRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  // Show welcome message when chat opens
  useEffect(() => {
    if (isOpen && messages.length === 0) {
      setMessages([{ type: 'bot', text: '👋 Hi! I’m your assistant from DigitalRaiz Creative Solutions. How can I help you today?' }]);
    }
  }, [isOpen]);

  const handleSend = async () => {
    if (!input.trim()) return;
  
    const userMessage = { type: 'user', text: input };
    setMessages((prev) => [...prev, userMessage]);
  
    const maxRetries = 3;
    let attempt = 0;
    let success = false;
  
    while (attempt < maxRetries && !success) {
      try {
        const res = await axios.post(
          `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent?key=${API_KEY}`,
          {
            contents: [{ parts: [{ text: input }] }],
          }
        );
  
        const reply = res.data.candidates?.[0]?.content?.parts?.[0]?.text || 'No response from Gemini.';
        setMessages((prev) => [...prev, { type: 'bot', text: reply }]);
        success = true;
      } catch (error) {
        attempt++;
        if (error.response?.status === 503 && attempt < maxRetries) {
          const delay = Math.pow(2, attempt) * 1000; // Exponential backoff
          await new Promise((resolve) => setTimeout(resolve, delay));
        } else {
          console.error(error);
          const errorMessage =
            error.response?.status === 503
              ? '⚠️ Gemini is temporarily overloaded. Please try again shortly.'
              : '❌ Error contacting Gemini API.';
          setMessages((prev) => [...prev, { type: 'bot', text: errorMessage }]);
          break;
        }
      }
    }
  
    setInput('');
  };
  

  return (
    <div>
      {/* Floating Icon */}
      <div
        onClick={() => setIsOpen(true)}
        style={{
          position: 'fixed',
          bottom: 20,
          right: 20,
          width: 60,
          height: 60,
          backgroundColor: '#1e88e5', // DigitalRaiz blue tone
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontSize: 30,
          cursor: 'pointer',
          boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
        }}
        title="Chat with DigitalRaiz AI"
      >
        🤖
      </div>

      {/* Chat Box */}
      {isOpen && (
        <div
          ref={chatRef}
          style={{
            position: 'fixed',
            bottom: 90,
            right: 20,
            width: 320,
            height: 420,
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            borderRadius: 10,
            padding: 10,
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            fontFamily: 'Arial, sans-serif',
          }}
        >
          {/* Header */}
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <strong style={{ color: '#1e88e5' }}>DigitalRaiz AI Assistant</strong>
            <button className='btn btn-dark' onClick={() => setIsOpen(false)} style={{ cursor: 'pointer' }}>✖</button>
          </div>

          {/* Chat History */}
          <div
            style={{
              flex: 1,
              overflowY: 'auto',
              marginBottom: 8,
              paddingRight: 5,
              fontSize: 14,
            }}
          >
            {messages.map((msg, idx) => (
              <div
                key={idx}
                style={{
                  textAlign: msg.type === 'user' ? 'right' : 'left',
                  marginBottom: 6,
                }}
              >
                <strong>{msg.type === 'user' ? 'You' : 'Assistant'}:</strong> {msg.text}
              </div>
            ))}
          </div>

          {/* Input */}
          <div style={{ display: 'flex', gap: 4 }}>
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Type a message..."
              style={{
                flex: 1,
                padding: 6,
                border: '1px solid #ccc',
                borderRadius: 4,
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleSend();
              }}
            />
            <button className="btn btn-primary" onClick={handleSend} style={{ padding: '6px 10px' }}>
            <i class="fa fa-telegram" aria-hidden="true"></i> Send
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
